import './i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress ResizeObserver loop warnings (common with third-party scripts like HubSpot)
const originalError = console.error;
const originalWarn = console.warn;

const isResizeObserverError = (arg) => {
  if (!arg) return false;
  const msg = typeof arg === 'string' ? arg : arg?.message || arg?.toString() || '';
  return /ResizeObserver/i.test(msg) || /loop completed/i.test(msg) || /undelivered notifications/i.test(msg);
};

console.error = (...args) => {
  if (args.some(arg => isResizeObserverError(arg))) {
    return;
  }
  originalError.apply(console, args);
};

console.warn = (...args) => {
  if (args.some(arg => isResizeObserverError(arg))) {
    return;
  }
  originalWarn.apply(console, args);
};

// Also catch window errors
const originalWindowError = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (isResizeObserverError(message) || (error && isResizeObserverError(error.message))) {
    return true; // Suppress the error
  }
  if (originalWindowError) {
    return originalWindowError(message, source, lineno, colno, error);
  }
  return false;
};

// Catch unhandled promise rejections that might contain ResizeObserver errors
window.addEventListener('unhandledrejection', (event) => {
  if (isResizeObserverError(event.reason) || isResizeObserverError(event.reason?.message)) {
    event.preventDefault();
  }
});

// Catch error events
window.addEventListener('error', (event) => {
  if (isResizeObserverError(event.message) || isResizeObserverError(event.error)) {
    event.preventDefault();
    return false;
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
